import { parseDomain } from '../helpers/parseDomain';
import { Injectable } from 'ng-metadata/core';

@Injectable()
export class EtomsService {
  public ETOMS_ENABLED: boolean = true; /*TODO: create an environment variable*/

  constructor() {}

  /**
   * Check if the ETOMS API is enabled
   */
  enabled() {
    const portal = this.portal();
    return this.ETOMS_ENABLED &&
      (portal.domain === 'travelvisa' || portal.domain === 'rushmytravelvisa');
  }

  /**
   * Return the current website domain
   */
  portal() {
    return parseDomain(window.location.href);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/etoms.service.ts